module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-coj_d-e9381ac094acb1c074564e44149720dc.jpg";